import React from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  CloseButton,
  Flex,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  Stack
} from "@chakra-ui/react";
import { MdFilterList } from "react-icons/md";
import { IoIosArrowDown } from "react-icons/io";

export const FilterContainer = (props) => {
  const { t } = useTranslation('common');
  const { children, isOpen, onToggle, onFilter, onClear, isExportable, onExport, isFilterDisabled, ...rest } = props;

  const onFilterHandler = () => {
    onToggle();
    onFilter();
  }

  const onClearHandler = () => {
    onToggle();
    onClear();
  }

  return (
    <Popover placement="bottom-start" isOpen={isOpen} onClose={onToggle} w={{ sm: "125px", lg: "75px" }}>
      <PopoverTrigger>
        <Button
          leftIcon={<MdFilterList />}
          rightIcon={<IoIosArrowDown />}
          onClick={onToggle}
          {...rest}
        >
          {t("system.labels.filters")}
        </Button>
      </PopoverTrigger>

      <PopoverContent w="100%" variant="light" p="5" ml={{ sm: "-10px", lg: "0" }}>
        <Flex gap="4" align="center" direction="column">
          <Flex w="100%" align="center" justify="space-between">
            <Text fontSize="md" fontWeight="bold">
              {t("system.labels.filters")}
            </Text>

            <CloseButton onClick={onToggle} />
          </Flex>

          <PopoverBody maxWidth={{ sm: "380px", lg: "900px" }}>
            <Flex direction="column" gap="4">
              {children}
            </Flex>
          </PopoverBody>

          <Flex w="100%" gap="4" align="center" justify="space-between">
            <Button
              w="125px"
              fontSize="sm"
              variant="outline"
              colorScheme="light"
              onClick={onClearHandler}
            >
              {t("system.actions.clear")}
            </Button>

            <Stack direction="row" spacing="10px" alignSelf={{ sm: "flex-start", lg: "auto" }}>
              {isExportable && (
              <Button
                w="125px"
                fontSize="sm"
                variant="outline"
                colorScheme="light"
                onClick={onExport}
              >
                {t("system.actions.export")}
              </Button>
              )}

              <Button
                w="125px"
                fontSize="sm"
                colorScheme="blue"
                onClick={onFilterHandler}
                isDisabled={isFilterDisabled} 
              >
                {t("system.actions.filter")}
              </Button>
            </Stack>

          </Flex>
        </Flex>
      </PopoverContent>
    </Popover>
  );
}